import React from 'react';
import Select from 'react-select';

const SelectField = (props) => {
  return (
    <Select
      defaultValue={ props.defaultValue }
      value={ props.value }
      name={ props.name }
      className={ `${props.className} custom-select-field-container` }
      classNamePrefix={ `${props.classNamePrefix} custom-select-field` }
      options={ props.options }
      placeholder={ `${props.placeholder} ${props.required === true ? ' *' : ''}` }
      aria-controls="datatable-basic"
      onBlur={ props.onBlur }
      isDisabled={ props.isDisabled }
      isClearable={ props.isClearable }
      isSearchable={ props.isSearchable }
      onChange={ props.onChange }
      menuPlacement={ props.placement ? props.placement : "auto" }
      menuPortalTarget={ props.menuPortalTarget }
      menuPosition={ props.menuPosition }
      styles={{
        menu: (base) => ({ ...base, zIndex: 9999 }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
}

SelectField.defaultProps = {
  name: '',
  isValidSelect: false,
  focusEffect: true,
  options: [],
  propsErrMsg: '',
  isDisabled: false,
  className: '',
  classNamePrefix: '',
  classNameFormGroup: '',
  classNameErrorMsg: 'mb-3',
  required: false,
  isClearable: false,
  isSearchable: false,
  placement: "bottom",
};

export { SelectField };
